import React from 'react';

function DarkModeToggle({ darkMode, toggleDarkMode }) {
  return (
    <button className="dark-mode-toggle" onClick={toggleDarkMode}>
      {darkMode ? <i className="fas fa-sun"></i>  : <i className="fas fa-moon"></i> }
    </button>
  );
}

export default DarkModeToggle;